import { useMemo } from "react";

import { useGlobalConfig } from "./useGlobalConfig";
import { useCurrencies } from "./useCurrencies";

interface ExchangeRates {
  [key: string]: string;
}

export function useExchangeRates(): ExchangeRates | undefined {
  const globalConfig = useGlobalConfig();
  const currency = useCurrencies();

  const exchangeRates = useMemo(() => {
    if (currency) {
      const exchanges: ExchangeRates = {};
      for (let i = 0; i < currency.data.length; i++) {
        exchanges[currency.data[i].currency_short] = currency.data[
          i
        ].exchange.toFixed(globalConfig?.exchange_rounding ?? 4);
      }
      return exchanges;
    }
  }, [currency, globalConfig]);

  return exchangeRates;
}
